import { backendAPI, transactionAPI } from "../api"
import { safeApiCall } from "../api/offline"
import { triggerAction } from "../constants"

export const meetingTransactionsLoadStarted = (bool) => ({
  type: "MEETING_TRANSACTION_LOAD_START",
  isloading: bool,
})

export const meetingTransactionsLoaded = (transactions) => ({
  type: "LOADED_MEETING_TRANSACTION",
  transactions,
})

export const meetingTransactionsLoadError = (bool) => ({
  type: "MEETING_TRANSACTION_LOAD_ERROR",
  error: bool,
})

export const fetchMeetingMemberTransactions =
  (memberId) => async (dispatch, getState) => {
    try {
      const meeting = getState().meeting?.ongoing

      const member = getState().loadedvslaMembers.find(({ id }) => id === memberId)

      if (!meeting || !member) {
        return
      }

      const meetingId = meeting?.id
      const res = await safeApiCall(
        {
          cacheEnabled: true,
          url: `/meetings/${meetingId}/members/${member.id}/transactions`,
        },
        async () =>
          backendAPI.get(
            `/meetings/${meetingId}/members/${member.id}/transactions`,
          ),
      )
      const parsed = res.data
        .map((t) => ({ ...t, full_name: member.full_name }))
        .filter(({ status }) => status !== "REVERSED")
      if (!member.pubkey) {
        console.log("Member pubkey not found for balance update", memberId)
        return
      }
      dispatch(triggerAction("SET_NONE_REVERSED_MEMBER_TRANSACTIONS", { [member.pubkey]: parsed }))
    } catch (error) {
      console.log("error ", error)
    }
  }